AFRAME.registerComponent('switch-table-chart', {
    init: function () {
        this._initVariables();

        if (this.el.sceneEl.hasLoaded) {
            this.onSceneLoaded();
        } else {
            this.el.sceneEl.addEventListener('loaded', this.onSceneLoaded.bind(this));
        }
    },

    _initVariables: function () {
        this.currentView = 'chart';
        this.btnChart = null;
        this.btnTable = null;
        this.isChartInCenter = true;
    },

    onSceneLoaded: function () {
        this.el.sceneEl.addEventListener('chart-type-changed', (e) => {
            const action = e.detail?.action;
            if (action === 'watchlist-reports') {
                this.show();
            } else {
                this.hide();
            }
        });

        this.el.sceneEl.addEventListener('theme-changed', () => {
            if (this.el.getAttribute('visible')) {
                this.render();
            }
        });

        this.el.sceneEl.addEventListener('watchlist-main-empty-state', (e) => {
            const active = e.detail?.active;
            if (active) {
                this.el.setAttribute('visible', false);
                const centerPanel = document.getElementById('large-center-panel');
                if (centerPanel) centerPanel.setAttribute('visible', false);
            } else {
                const chartCtrlEl = document.querySelector('[chart-type-control]');
                let isWatchlist = false;
                if (chartCtrlEl) {
                    const attr = chartCtrlEl.getAttribute('chart-type-control');
                    if (attr && attr.selectedPrimeAction === 'watchlist-reports') {
                        isWatchlist = true;
                    }
                }
                
                if (isWatchlist) {
                    this.el.setAttribute('visible', true);
                    if (this.currentView === 'chart') {
                        this.switchToChart();
                    } else {
                        this.switchToTable();
                    }
                }
            }
        });
    },

    show: function () {
        this.el.setAttribute('visible', true);
        
        this.render();

        this.switchToChart();
    },

    hide: function () {
        this.el.setAttribute('visible', false);
        
        const content = this.el.querySelector('#switch-table-chart-content');
        if (content) content.innerHTML = '';
        this.btnChart = null;
        this.btnTable = null;

        if (this.currentView === 'table') {
            this.switchToChart();
        }
    },

    switchToChart: function () {
        this.currentView = 'chart';

        const centerPanel = document.getElementById('large-center-panel');
        if (centerPanel) {
            centerPanel.setAttribute('visible', true);
            centerPanel.querySelectorAll('[stock-bar]').forEach(bar => {
                bar.setAttribute('data-raycastable', '');
            });
        }

        this.el.sceneEl.emit('watchlist-show-chart');

        this.updateButtonStyles();
    },

    switchToTable: function () {
        this.currentView = 'table';

        const centerPanel = document.getElementById('large-center-panel');
        if (centerPanel) {
            centerPanel.setAttribute('visible', false);
            centerPanel.querySelectorAll('[stock-bar]').forEach(bar => {
                bar.removeAttribute('data-raycastable');
            });
        }

        this.el.sceneEl.emit('watchlist-show-table');

        this.updateButtonStyles();
    },

    setCenterState: function(isCenter, transitionTime = 600) {
        this.isChartInCenter = isCenter;
        
        if (!isCenter) {
            this.el.setAttribute('animation__scale', {
                property: 'scale',
                to: '0.001 0.001 0.001',
                dur: transitionTime,
                easing: 'easeInOutQuad'
            });
            if (this.btnChart) this.btnChart.removeAttribute('data-raycastable');
            if (this.btnTable) this.btnTable.removeAttribute('data-raycastable');
        } else {
            this.el.setAttribute('animation__scale', {
                property: 'scale',
                to: '2 2 2',
                dur: transitionTime,
                easing: 'easeInOutQuad'
            });
            if (this.btnChart) this.btnChart.setAttribute('data-raycastable', '');
            if (this.btnTable) this.btnTable.setAttribute('data-raycastable', '');
        }
    },

    updateButtonStyles: function () {
        if (!this.btnChart || !this.btnTable) return;

        if (this.currentView === 'chart') {
            this.btnChart.setAttribute('ui-button', 'selected', true);
            this.btnTable.setAttribute('ui-button', 'selected', false);
        } else {
            this.btnTable.setAttribute('ui-button', 'selected', true);
            this.btnChart.setAttribute('ui-button', 'selected', false);
        }
    },

    _isLightMode: function() {
        const mainSettingsEl = document.querySelector('[main-settings]');
        if (mainSettingsEl && mainSettingsEl.components && mainSettingsEl.components['main-settings']) {
            return mainSettingsEl.components['main-settings'].data.themeMode === 'Light';
        }

        if (typeof getCacheItem === 'function') {
            const settings = getCacheItem('mainSettings');
            if (settings && settings.themeMode) {
                return settings.themeMode === 'Light';
            }
        }

        return false;
    },

    render: function () {
        let content = this.el.querySelector('#switch-table-chart-content');
        if (!content) {
            content = document.createElement('a-entity');
            content.setAttribute('id', 'switch-table-chart-content');
            this.el.appendChild(content);
        }
        content.innerHTML = '';

        const isLight = this._isLightMode();

        const rowHeight = 0.05;
        const btnWidth = 0.15;
        const padding = 0.01;

        const container = document.createElement('a-entity');
        container.setAttribute('position', '0 0 0.01');
        content.appendChild(container);
        const totalWidth = 2 * btnWidth + 1 * padding;
        const startX = -totalWidth / 2 + btnWidth / 2;

        const btnChart = document.createElement("a-entity");
        btnChart.setAttribute("ui-button", {
            label: "Chart",
            width: btnWidth,
            height: rowHeight,
            depth: 0.012,
            type: "rounded-box",
            colorScheme: 'primary',
            selected: this.currentView === 'chart',
            radius: 0.01,
            preferredFontSize: 0.02,
            textZp: 0.0065
        });
        btnChart.setAttribute('position', `${startX} 0 0`);
        if (this.isChartInCenter !== false) {
            btnChart.setAttribute('data-raycastable', '');
        }
        btnChart.addEventListener('click', () => {
            if (this.currentView !== 'chart') {
                this.switchToChart();

                if(window.gtag) gtag('event', `VR_TopNav_WatchlistChart`);
            }
        });
        container.appendChild(btnChart);
        this.btnChart = btnChart;

        const btnTable = document.createElement("a-entity");
        btnTable.setAttribute("ui-button", {
            label: "Table",
            width: btnWidth,
            height: rowHeight,
            depth: 0.012,
            type: "rounded-box",
            colorScheme: 'primary',
            selected: this.currentView === 'table',
            radius: 0.01,
            preferredFontSize: 0.02,
            textZp: 0.0065
        });
        btnTable.setAttribute('position', `${startX + btnWidth + padding} 0 0`);
        if (this.isChartInCenter !== false) {
            btnTable.setAttribute('data-raycastable', '');
        }
        btnTable.addEventListener('click', () => {
            if (this.currentView !== 'table') {
                this.switchToTable();

                if(window.gtag) gtag('event', `VR_TopNav_WatchlistTable`);
            }
        });
        container.appendChild(btnTable);
        this.btnTable = btnTable;
    }
});
